<template>
    <BModal v-model="isOpen" size="md" centered hide-footer title="Edit invoice number">
        <div class="row">
            <AppInput :value="invoice.number"
                      label="Invoice no."
                      field="number"
                      :errors="errors"
                      @input="updateInvoiceProps({ number: $event })"
                      class="col-12"/>
        </div>
        <div class="row mt-3">
            <div class="col-12 text-right">
                <button class="btn btn-primary" @click="save">Save</button>
            </div>
        </div>
    </BModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';
import Errors from '../../utils/errors';
import AppInput from '../form/AppInput';

export default {
  data() {
    return {
      errors: new Errors(),
    };
  },
  components: {
    AppInput,
    BModal,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.invoices.isInvoiceNoModalOpen;
      },
      set(val) {
        this.$store.commit('invoices/isInvoiceNoModalOpen', val);
      },
    },
    ...mapGetters({
      invoice: 'invoices/invoice',
    }),
  },
  methods: {
    save() {
      this.$store.commit('invoices/isInvoiceNoModalOpen', false);
      this.$store.dispatch('invoices/updateInvoice');
    },
    updateInvoiceProps(props) {
      this.$store.dispatch('invoices/updateInvoiceProps', props);
    },
  },
};
</script>
